import { connect } from 'react-redux'
import Plannification from '../../../pages/main/Programmer/Plannification'
import {
  changeToursTypeState,
  createTours,
  handleCheck,
  recalculateTours,
  resetCheckedAll,
  simulateTours,
  viewPlannification,
  removeError,
  activeTourAction,
  exportTours,
  fetchCourses,
} from '../../../redux/simulateTournee/actions'
import {
  getFleet,
  getSimulationTours,
  getSimulationUnserved,
  getTourType,
  getSimulationsIsLoading,
  getSimulationIsError,
  getSimulationsErrorMessage,
  getIsErrorAffectPlanning,
  getIsOptimisationCoursesFiles,
  getfilterCourses,
  getSelectedCourses,
  getFocusedTours,
  getcheckedRec,
} from '../../../redux/simulateTournee/selectors'

const mapStateToProps = (state) => ({
  unservedTours: getSimulationUnserved(state),
  planning: getSimulationTours(state),
  fleet: getFleet(state),
  isOnePickUp: getTourType(state),
  isSimLoading: getSimulationsIsLoading(state),
  isSimError: getSimulationIsError(state),
  simulationErrorMessage: getSimulationsErrorMessage(state),
  isErrorAffectPlanning: getIsErrorAffectPlanning(state),
  isOptimisationCoursesFiles: getIsOptimisationCoursesFiles(state),
  filtersValues: getfilterCourses(state),
  selectedCourses: getSelectedCourses(state),
  focusedTours: getFocusedTours(state),
  tourRecChecked: getcheckedRec(state),
})

const mapDisptachToProps = (dispatch) => ({
  createTours: (data) => dispatch(createTours(data)),
  handleToursReOrder: (
    simTours,
    deliveryDate,
    isOnePickUp,
    isFile,
    isUnservedChanged,
    newUnservedTours
  ) => {
    dispatch(
      recalculateTours(
        simTours,
        deliveryDate,
        isOnePickUp,
        isFile,
        isUnservedChanged,
        newUnservedTours
      )
    )
  },
  changeToursTypeState: (updatedTours) => {
    dispatch(changeToursTypeState(updatedTours))
  },
  simulateTours: (data, isOnePickUp) => dispatch(simulateTours(data, isOnePickUp)),
  handleCheck: (id) => dispatch(handleCheck(id)),

  resetCheckedAll: () => dispatch(resetCheckedAll()),
  viewPlannification: (viewPlannif) => dispatch(viewPlannification(viewPlannif)),
  removeError: (isViewPlannification) => dispatch(removeError(isViewPlannification)),
  activeTourAction: () => dispatch(activeTourAction()),
  exportTours: (data, isDownload) => dispatch(exportTours(data, isDownload)),
  fetchCourses: (courses) => dispatch(fetchCourses(courses)),
})
export default connect(mapStateToProps, mapDisptachToProps)(Plannification)
